import { useUpdated } from "@common/lib/hooks";
import { isBrowser } from "@common/lib/misc";
import classNames from "classnames";
import * as React from "react";

export type HTMLProps = React.HTMLProps<any> & {
  isNewLineDisabled?: boolean;
  html?: string;
  tag?: string;
  children?: any;
};

const HTML = (props: HTMLProps) => {
  const ref = React.useRef<HTMLElement>(null);

  const setHTML = (html: string | undefined) => {
    if (!html || !isBrowser()) return;

    const el = ref.current as HTMLElement;
    $(el).html(html);
  };

  React.useLayoutEffect(() => setHTML(props.html), []);

  useUpdated(() => setHTML(props.html), [props.html]);

  const { tag = "div", html, className, isNewLineDisabled, ...rest } = props;
  const Tag = tag as unknown as React.ComponentType<React.HTMLProps<any>>;

  return (
    <Tag
      ref={ref}
      className={classNames("wsc_text_content", className)}
      {...rest}
      dangerouslySetInnerHTML={{ __html: props.html ?? "" }}
    />
  );
};
export default HTML;
